// Opaque to this app: read, hand back unchanged.
export const RETURN_TARGET_PARAM = 'returnUrl'

export function readReturnTarget(search: string): string | null {
  const value = new URLSearchParams(search).get(RETURN_TARGET_PARAM)
  return value === null || value === '' ? null : value
}
